import React from "react";
import { Spinner } from "@bookingcom/bui-react";
import Frame from "./Frame/index.js";
import NoSSR from "../../app/NoSSR/index.js";
const LoadingStatus = function () {
    return (React.createElement(NoSSR, null,
        React.createElement(Frame, { m: 4, alignItems: "center", justifyContent: "center" },
            React.createElement(Spinner, null))));
};
export default LoadingStatus;
